export const translations = {
  CLICKORDRAG: {
    sv: 'Klicka eller dra en fil hit',
    en: 'Click or drag a file here',
    da: 'Klik eller træk en fil hertil',
    fi: 'Klikkaa tai vedä tiedosto tähän',
    no: 'Klikk eller dra en fil hit',
  },
  ACCEPTEDFORMATS: {
    sv: 'Filformat som stöds',
    en: 'Supported formats',
    da: 'Støttede filformater',
    fi: 'Tuetut tiedostomuodot',
    no: 'Understøttede filformater',
  },
  MAXFILESIZE: {
    sv: 'Max filstorlek',
    en: 'Max filesize',
    da: 'Max filstørrelse',
    fi: 'Maksimitiedostokoko',
    no: 'Maks filstørrelse',
  },
  REMOVE_FILE: {
    sv: 'Ta bort filen',
    en: 'Remove file',
    da: 'Fjern fil',
    fi: 'Poista tiedosto',
    no: 'Fjern fil',
  },
};
